import { useCallback, useEffect, useState } from "react";

const DEFAULT_COOKIE = "crime_stalkers_seen";

function getCookie(name: string): string | undefined {
  if (typeof document === "undefined") return undefined;
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()!.split(";").shift();
  return undefined;
}

function setCookie(name: string, value: string, days = 365) {
  if (typeof document === "undefined") return;
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = `; expires=${date.toUTCString()}`;
  document.cookie = `${name}=${encodeURIComponent(value || "")}${expires}; path=/; SameSite=Lax`;
}

export default function useFirstVisit(cookieName = DEFAULT_COOKIE) {
  const [seen, setSeen] = useState<boolean>(() => !!getCookie(cookieName));

  const markSeen = useCallback(
    (days = 365) => {
      setCookie(cookieName, "1", days);
      setSeen(true);
    },
    [cookieName]
  );

  useEffect(() => {
    setSeen(!!getCookie(cookieName));
  }, [cookieName]);

  return { seen, markSeen } as const;
}
